import "./App.css";
import React from "react";

import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./pages/Layout";
import Home from "./pages/Home";
import CISA from "./pages/CISA/CISA";
import CCNA from "./pages/CCNA/CCNA";
import GIT from "./pages/GIT/GIT";
import LEADERSHIP from "./pages/LEADERSHIP/LEADERSHIP";
import CPA from "./pages/CPA/CPA";
//import Contact from "./pages/Contact";
import NoPage from "./pages/NoPage";

class App extends React.Component {
  

  render() {
    return (
      <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="CISA" element={<CISA />} />
          <Route path="CCNA" element={<CCNA />} />    
          <Route path="GIT" element={<GIT />} />
          <Route path="CPA" element={<CPA />} />
          <Route path="LEADERSHIP" element={<LEADERSHIP />} />
          <Route path="*" element={<NoPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
    );
  }
}

export default App;
